import React from 'react';
import Icon from '../Icon';
import svg from '../icons/status-information-onlight.js';

const IconStatusInformationOnlight = (props) => <Icon {...props} svg={svg} />;

IconStatusInformationOnlight.displayName = 'IconStatusInformationOnlight';

export default IconStatusInformationOnlight;
